import {
  EMAIL_ERROR_MESSAGE,
  REQUIRED_ERROR_MESSAGE,
  LEAD_NAME_KEY,
  LEAD_EMAIL_KEY,
} from 'containers/LeadGen/constants'

import {
  FIRST_NAME_KEY,
  LAST_NAME_KEY,
  PHONE_KEY,
  DATE_BIRTH_KEY,
  ACCOUNT_PIN_KEY,
  PHONE_ERROR_MESSAGE,
  DATE_ERROR_MESSAGE,
  ACCOUNT_PIN_ERROR_MESSAGE,
} from 'containers/stages/PersonalInfoStage/constants'

import {
  LANDLINE_KEY,
  OWNS_SERVICE_KEY,
} from 'containers/stages/OwnerCheckStage/constants'

import {
  QFF_FIRST_NAME_KEY,
  QFF_LAST_NAME_KEY,
  QFF_EMAIL_KEY,
  QFF_REFERENCE_KEY,
  QFF_NUMBER_KEY,
  QFF_NUMBER_ERROR_MESSAGE,
  QFF_REFERENCE_ERROR_MESSAGE,
} from 'containers/QantasFrequentFlyer/constants'

import { REQUIRED_SELECTION } from 'containers/stages/MultipleAddressStage/constants'

import {
  NUMBER_ERROR_MESSAGE,
  POSTCODE_ERROR_MESSAGE,
  UNIT_NUMBER_KEY,
  UNIT_TYPE_KEY,
  STREET_NUMBER_KEY,
  STREET_NAME_KEY,
  STREET_TYPE_KEY,
  SUBURB_KEY,
  STATE_KEY,
  POSTCODE_KEY,
  STATE_SELECTION,
  UNIT_TYPE_SELECTION,
  STREET_TYPE_SELECTION,
} from 'components/Address/constants'

import {
  ADDRESS_ERROR_MESSAGE,
  ADDRESS_ID_KEY,
  ADDRESS_TEXT_KEY,
} from 'components/AutocompleteAddress/constants'

function errorsOrTrue(errors) {
  if (Object.keys(errors).length === 0) {
    return true
  }
  return errors
}

export function validateEmail(email) {
  const expression = /^(.+)@(.+){2,}\.(.+){2,}$/
  return expression.test(email)
}

export function validateNotBlank(name) {
  return name && name.length > 0
}

export const validateName = name => validateNotBlank(name)

export function validatePhone(number, required = true) {
  if (!required && !number) return true
  // Validates land line and mobile numbers.
  // Starting numbers must be between 01 and 08 or optionally +61
  const expression = /^(0|\+?61)[1-8]\d{8}$/g
  return expression.test(number.replace(/\s/g, ''))
}

export function validateDate(date) {
  // validates dd/mm/yyyy
  const expression = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/
  return expression.test(date)
}

export function validateAccountPin(number) {
  const expression = /^[0-9]{4}$/
  return expression.test(number)
}

export function validateAddress(addressId) {
  return !!addressId
}

export function validateStreetNumber(input, required) {
  if (!required && !input) return true
  const expression = /^\d+(-\d+|[a-zA-Z])?$/
  return expression.test(input || '')
}

export function validateStreetName(input, required) {
  if (!required && !input) return true
  return !!input
}

export function validatePostcode(input) {
  const expression = /^\d{4}$/
  return expression.test(input || '')
}

export function validateState(input) {
  return STATE_SELECTION.indexOf(input) !== -1
}

export function validateStreetType(input) {
  return STREET_TYPE_SELECTION.indexOf(input) !== -1
}

export function validateUnitType(input, required) {
  if (!required && !input) return true
  return UNIT_TYPE_SELECTION.indexOf(input) !== -1
}

function validateOwner(input) {
  return input === true || input === false
}

export function validateQantasFrequentFlyer(number, required = true) {
  if (!required && !number) return true
  const expression = /^\d{7,16}$/g
  return expression.test(number.replace(/\s/g, ''))
}

export function validateReference(number, required = true) {
  if (!required && !number) return true
  const expression = /^[0-9A-Za-z]{8,}$/g
  return expression.test(number.replace(/\s/g, ''))
}

export function validateAddressForm(data, manualAddress) {
  const errors = {}
  if (!manualAddress) {
    if (!data[ADDRESS_ID_KEY]) {
      errors[ADDRESS_TEXT_KEY] = ADDRESS_ERROR_MESSAGE
    }
  } else {
    if (!validateStreetNumber(data[UNIT_NUMBER_KEY], false)) {
      errors[UNIT_NUMBER_KEY] = NUMBER_ERROR_MESSAGE
    }
    if (!validateUnitType(data[UNIT_TYPE_KEY], !!data[UNIT_NUMBER_KEY])) {
      errors[UNIT_TYPE_KEY] = REQUIRED_ERROR_MESSAGE
    }
    if (!validateStreetNumber(data[STREET_NUMBER_KEY], true)) {
      errors[STREET_NUMBER_KEY] = NUMBER_ERROR_MESSAGE
    }
    if (!validateStreetName(data[STREET_NAME_KEY], true)) {
      errors[STREET_NAME_KEY] = REQUIRED_ERROR_MESSAGE
    }
    if (!validateStreetType(data[STREET_TYPE_KEY])) {
      errors[STREET_TYPE_KEY] = REQUIRED_ERROR_MESSAGE
    }
    if (!validateNotBlank(data[SUBURB_KEY])) {
      errors[SUBURB_KEY] = REQUIRED_ERROR_MESSAGE
    }
    if (!validateState(data[STATE_KEY])) {
      errors[STATE_KEY] = REQUIRED_ERROR_MESSAGE
    }
    if (!validatePostcode(data[POSTCODE_KEY])) {
      errors[POSTCODE_KEY] = POSTCODE_ERROR_MESSAGE
    }
  }

  return errorsOrTrue(errors)
}

export function validateForm(formData, manualAddress) {
  const errors = {}
  if (!validateEmail(formData[LEAD_EMAIL_KEY])) errors[LEAD_EMAIL_KEY] = EMAIL_ERROR_MESSAGE
  if (!validateName(formData[LEAD_NAME_KEY])) errors[LEAD_NAME_KEY] = REQUIRED_ERROR_MESSAGE

  const addressErrors = validateAddressForm(formData, manualAddress)
  if (addressErrors !== true) {
    Object.assign(errors, addressErrors)
  }

  if (Object.keys(errors).length === 0) {
    return true
  }
  return errors
}

export function validatePersonalInfoForm(formData) {
  const errors = {}
  if (!validateName(formData[FIRST_NAME_KEY])) errors[FIRST_NAME_KEY] = REQUIRED_ERROR_MESSAGE
  // TODO: middle name is optional
  // if (!validateName(formData[MIDDLE_NAME_KEY])) errors[MIDDLE_NAME_KEY] = REQUIRED_ERROR_MESSAGE
  if (!validateName(formData[LAST_NAME_KEY])) errors[LAST_NAME_KEY] = REQUIRED_ERROR_MESSAGE

  /* Add new validation for these its just checking as name */
  if (!validatePhone(formData[PHONE_KEY])) errors[PHONE_KEY] = PHONE_ERROR_MESSAGE
  if (!validateDate(formData[DATE_BIRTH_KEY])) errors[DATE_BIRTH_KEY] = DATE_ERROR_MESSAGE
  if (!validateAccountPin(formData[ACCOUNT_PIN_KEY])) errors[ACCOUNT_PIN_KEY] = ACCOUNT_PIN_ERROR_MESSAGE

  if (Object.keys(errors).length === 0) {
    return true
  }
  return errors
}

export function validateMultiAddressForm(selectedAddress) {
  return validateAddress(selectedAddress) ? true : REQUIRED_SELECTION
}

export function validateOwnerForm(formData) {
  const errors = {}
  if (!validateOwner(formData[OWNS_SERVICE_KEY])) errors[OWNS_SERVICE_KEY] = REQUIRED_ERROR_MESSAGE

  if (Object.keys(errors).length === 0) {
    return true
  }
  return errors
}

export function validateQffForm(formData) {
  const errors = {}
  if (!validateEmail(formData[QFF_EMAIL_KEY], false)) errors[QFF_EMAIL_KEY] = EMAIL_ERROR_MESSAGE
  if (!validateNotBlank(formData[QFF_FIRST_NAME_KEY])) errors[QFF_FIRST_NAME_KEY] = REQUIRED_ERROR_MESSAGE
  if (!validateNotBlank(formData[QFF_LAST_NAME_KEY])) errors[QFF_LAST_NAME_KEY] = REQUIRED_ERROR_MESSAGE
  if (!validateReference(formData[QFF_REFERENCE_KEY])) errors[QFF_REFERENCE_KEY] = QFF_REFERENCE_ERROR_MESSAGE
  if (!validateQantasFrequentFlyer(formData[QFF_NUMBER_KEY])) errors[QFF_NUMBER_KEY] = QFF_NUMBER_ERROR_MESSAGE
  if (Object.keys(errors).length === 0) {
    return true
  }
  return errors
}

export function flattenErrors(errors) {
  // Flatten error objects coming back from the server
  // Django MAY return errors like this:
  // {'field1': ['An error']}
  const newErrors = {}
  Object.keys(errors).forEach((key) => {
    if (typeof errors[key] === 'string') {
      newErrors[key] = errors[key]
    } else {
      const [err] = errors[key]
      newErrors[key] = err
    }
  })
  return newErrors
}



// WEBPACK FOOTER //
// ./utilities/formValidator.util.js